import { create } from 'zustand'

interface ModalI24State {
  modalI24: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalI24: (modalI24: { isOpen: boolean; onSuccess?: () => void }) => void
  reset: () => void
}

const initialState = {
  modalI24: {
    isOpen: false
  }
}

export const useModalI24Store = create<ModalI24State>()((set) => ({
  ...initialState,
  setModalI24: (modalI24) => set({ modalI24 }),
  reset: () =>
    set({
      modalI24: initialState.modalI24
    })
}))
